import themeColors, { themeFontsSize } from "@GeriMed/styles/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import Link from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css, ThemeProps, withTheme } from "styled-components";

const enum fields {
    backgroundImage = "backgroundImage",
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundImage]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
    myListsPageNavLink: getPageLinkByPageType(state, "MyListsPage"),
    invoicesPageLink: getPageLinkByPageType(state, "InvoiceHistoryPage"),
    savedOrderListPageLink: getPageLinkByPageType(state, "SavedOrderListPage"),
    purchaseHistoryPageLink: getPageLinkByPageType(state, "PurchaseHistoryPage"),
    officeSuppliesPageLink: getPageLinkByPageType(state, "OfficeSuppliesPage"),
    formularyListPageLink: getPageLinkByPageType(state, "FormularyListPage"),
    medicalEquipmentPageLink: getPageLinkByPageType(state, "MedicalEquipmentPage"),
});

const Ul = styled.ul`
    display: block;
    width:100%;
    max-width: 1200px;
    margin:5px auto;
    padding: 0 5px;
`;

type LiProps = { backgroundUrl?: string; };

const StyledListItem = styled.li<LiProps>`
    ${({ backgroundUrl }) =>
    backgroundUrl &&
    `&:before {
        background: url(${backgroundUrl}) no-repeat;
        background-size: 126px
        }
    `}
`;

export interface HeaderSignInStyles {
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    secondaryNavWrapper?:InjectableCss;
    secondaryNavLink?:InjectableCss;
}

export const headerSignInStyles: HeaderSignInStyles = {
    signOutWrapper: {
        css: css`
            display: inline-flex;
            padding: 6px 0;
        `,
    },
    secondaryNavWrapper:{
        css: css`
        display: block;
        padding: 0;

            .secondary-nav {
                display: flex;
                padding: 0 15px;
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                        display:block;
                        `,
                    ],
                    "max",
                )}
            }
            .secondary-nav-item {
                display: flex;
                flex-direction:row;
                width: fit-content;
                padding: 10px;
                align-items: center;
                padding: 0 1em 0 .7375em;

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                        display:block;
                        width: 100%;
                        border-bottom: 1px solid #dfdfdf;

                        &:last-child {
                            border-bottom: none;
                        }
                        `,
                    ],
                    "max",
                )}

                @media screen and (min-width: 768px) and (max-width: 1192px) {
                    padding: .25em .5em .25em .1em;
                    a {
                        ${themeFontsSize.size12};
                    }
                }

                a {
                    font-size: ${themeFontsSize.size14};
                    line-height: ${themeFontsSize.size14};
                    text-decoration: none;
                    vertical-align: middle;

                    &:hover{

                    }
                }
                > span {
                    height: 24px;
                    width: 24px;
                    padding:20px 16px;
                    display: inline-block;
                    vertical-align: middle;
                }
            }
            .icon-img{
                background-size: 126px !important;
            }
            .purchasehistory {
                + a span, +a:hover span{
                    color: #3079f0;
                }
            }
            
            .formulary {
                + a span, +a:hover span{
                    color: ${themeColors.brightGreen};
                }
            }
            
            .supplies {              
                + a span, +a:hover span{
                    color: #f38507;
                }
            }
            
            .medical-equipment-link {
                + a span, +a:hover span{
                    color: #ffa809;
                }
            }
            
            .orderform {
                + a span, +a:hover span{
                    color: #3e6699;
                }
            }
            
            .pastinvoices {
                + a span, +a:hover span{
                    color: #3e6699;
                }
            }
            .savedcarts {
                + a span, +a:hover span{
                    color: #3e6699;
                }
            }

        `,
    },
    titleClickable: {
        css: css`
            margin-left: 10px;
        `,
    },
    titleIcon: {
        size: 22,
    },
    titleTypography: {
        css: css`
            margin-left: 10px;
            max-width: 150px;
        `,
        ellipsis: true,
        transform: "uppercase",
    },
    signOutClickable: {
        css: css`
            flex: 0 0 auto;
            margin-left: 16px;
            text-transform: uppercase;
        `,
    },
};


type Props =  OwnProps & ReturnType<typeof mapStateToProps>;

let icon: React.ComponentType<IconPresentationProps>;

export const HeaderMenuList = ({
    session,
    myListsPageNavLink,
    invoicesPageLink,
    savedOrderListPageLink,
    fields,
    purchaseHistoryPageLink,
    officeSuppliesPageLink,
    formularyListPageLink,
    medicalEquipmentPageLink,
}: Props) => {
    const styles = useMergeStyles("headerSignIn", headerSignInStyles);
    const isAuthenticated = session?.isAuthenticated && !session?.isGuest;
    const myListsPageUrl = myListsPageNavLink ? myListsPageNavLink.url : undefined;
    const invoicesPageUrl = invoicesPageLink ? invoicesPageLink.url : undefined;
    const savedOrderListPageUrl = savedOrderListPageLink ? savedOrderListPageLink.url : undefined;

    const purchaseHistoryPageUrl = purchaseHistoryPageLink ? purchaseHistoryPageLink.url : undefined;
    const officeSuppliesPageUrl = officeSuppliesPageLink ? officeSuppliesPageLink.url : undefined;
    const formularyListPageUrl = formularyListPageLink ? formularyListPageLink.url : undefined;
    const medicalEquipmentPageUrl = medicalEquipmentPageLink ? medicalEquipmentPageLink.url : undefined;
    
    return (
       <>
       { isAuthenticated && (
        <>
            <StyledWrapper className="secondary-nav-wrap" {...styles.secondaryNavWrapper}>
                <Ul className="secondary-nav" >
                    <StyledListItem className="secondary-nav-item">
                        <Typography as="span" className="purchasehistory icon-img" style={{ background: `url(${fields.backgroundImage}) no-repeat -45px -149px` }}>&nbsp;</Typography>
                                <Link {...styles.secondaryNavLink} href={purchaseHistoryPageUrl} className="nav-link">
                            {translate("Purchase History")}
                        </Link>
                    </StyledListItem>
                    <StyledListItem className="secondary-nav-item">
                        <Typography as="span" className="formulary icon-img" style={{ background: `url(${fields.backgroundImage}) no-repeat -87px -149px` }}>&nbsp;</Typography>
                                <Link {...styles.secondaryNavLink} href={formularyListPageUrl} className="nav-link">
                            {translate("Formulary List")}
                        </Link>
                    </StyledListItem>
                    <StyledListItem className="secondary-nav-item"> 
                        <Typography as="span" className="supplies icon-img" style={{ background: `url(${fields.backgroundImage}) no-repeat -87px -192px` }}>&nbsp;</Typography>
                                <Link {...styles.secondaryNavLink} href={officeSuppliesPageUrl} className="nav-link">
                            {translate("Office Supplies")}
                        </Link>
                    </StyledListItem>
                    <StyledListItem className="secondary-nav-item"> 
                        <Typography as="span" className="medical-equipment-link icon-img" style={{ background: `url(${fields.backgroundImage}) no-repeat 0px -331px` }}>&nbsp;</Typography>
                        <Link {...styles.secondaryNavLink} href={medicalEquipmentPageUrl} className="nav-link">
                            {translate("Medical Equipment")}
                        </Link>
                    </StyledListItem>
                    <StyledListItem  className="secondary-nav-item"> 
                        <Typography as="span" className="orderform icon-img" style={{ background: `url(${fields.backgroundImage}) no-repeat -45px -190px` }}>&nbsp;</Typography>
                        <Link {...styles.secondaryNavLink} href={myListsPageUrl} className="nav-link">
                            {translate("Order Forms")}
                        </Link>
                    </StyledListItem>
                    <StyledListItem  className="secondary-nav-item">
                        <Typography as="span" className="pastinvoices" style={{ background: `url(${fields.backgroundImage}) no-repeat -4px -178px` }}>&nbsp;</Typography>
                        <Link {...styles.secondaryNavLink} href={invoicesPageUrl} className="nav-link">
                            {translate("Invoice History")}
                        </Link>
                    </StyledListItem>
                    <StyledListItem className="secondary-nav-item">
                        <Typography as="span" className="savedcarts" style={{ background: `url(${fields.backgroundImage}) no-repeat -4px -178px` }}>&nbsp;</Typography>
                        <Link {...styles.secondaryNavLink} href={savedOrderListPageUrl} className="nav-link">
                            {translate("Saved Order")}
                        </Link>
                    </StyledListItem>
                </Ul>
            </StyledWrapper>
        </>
        )}
       </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(HeaderMenuList),
    definition: {
        displayName: "Header Menu List",
        group: "Common",
        fieldDefinitions: [
            {
                fieldType: "Contextual",
                name: fields.backgroundImage,
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                isRequired: true,
            }
        ],
    },
    
};

export default widgetModule;
